/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2HIPAAIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2HIPAAIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2HIPAAIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1",
  fill3 = "#fff"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2HIPAAIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-1Hgi5r': alignSelf,'--mt-2-1Hgi5r': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1Hgi5r': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1Hgi5r': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1Hgi5r': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1Hgi5r': opacity,'--w-10-1Hgi5r': typeof width === 'number' ? `${width}px` : width,'--h-11-1Hgi5r': typeof height === 'number' ? `${height}px` : height,'--f-12-1Hgi5r': fill,'--a-7-1Hgi5r': isAnimated ? animation : "none",'--sd-8-1Hgi5r': isAnimated ? strokeDashoffset : 0,'--sd-9-1Hgi5r': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<rect
  data-testid="Tysiav2HIPAAIcon.SvgRect"
  data-view-path={viewPath}
 rx={2}
 style={{'--f-12-1Hgi5r': fill2}}
 className={`views-block ${styles.SvgRect}`}
/>
<path
  data-testid="Tysiav2HIPAAIcon.SvgPath"
  data-view-path={viewPath}
 d="M8.361 2.853H6.96a.525.525 0 00-.377.16l-.048.05a.563.563 0 01-.382.17l.005-.4a.676.676 0 10-.316 0l.004.4a.558.558 0 01-.38-.17l-.047-.05a.53.53 0 00-.378-.16H3.638a.388.388 0 000 .776h.215a.388.388 0 00.386.421h.215l-.002.034c0 .214.174.388.388.388h1.02l.004.327-.074.01a1.06 1.06 0 00-.308.105.518.518 0 00-.21.207.425.425 0 00-.043.135.356.356 0 00.01.15l-.444.36h.087v.085l.442-.448a1.47 1.47 0 00.088-.02c.046-.011.086-.023.123-.034.075-.024.134-.047.19-.07a.635.635 0 01.145-.053l.014 1.276-.006.006c-.052.051-.113.103-.174.16a2.277 2.277 0 00-.183.185.961.961 0 00-.156.234.628.628 0 00.021.577c.05.087.116.16.184.221.069.061.14.113.21.16l.121.08.012 1.091-.041.03a2.53 2.53 0 00-.196.153.712.712 0 00-.16.194.306.306 0 00-.024.242.505.505 0 00.134.2l.013-.01a.486.486 0 01-.092-.2.252.252 0 01.05-.193.65.65 0 01.163-.15c.049-.034.1-.065.154-.095l.012 1.113h.148l.013-1.21.092-.054c.072-.043.144-.088.213-.145a.663.663 0 00.18-.21.397.397 0 00.041-.14.638.638 0 00-.067-.393.9.9 0 00-.164-.218 2.176 2.176 0 00-.195-.17L6.1 7.892l.011-1.055a4.299 4.299 0 00.124-.108 1.853 1.853 0 00.136-.136c.115-.125.222-.26.308-.409a1.577 1.577 0 00.152-.36l.015-.065.006-.033.006-.035a.734.734 0 00-.155-.575.87.87 0 00-.253-.209.973.973 0 00-.316-.104l.003-.332h1.02a.388.388 0 00.389-.388l-.002-.033h.215a.388.388 0 00.386-.422h.215a.388.388 0 000-.776zm-2.637 4.67a.313.313 0 01.01-.295.73.73 0 01.11-.147l.045-.045.008.695a.665.665 0 01-.173-.208zm.439.791a.72.72 0 01.132.147.416.416 0 01.07.262v.022a.123.123 0 01-.002.019c-.002.013-.006.025-.01.038a.444.444 0 01-.11.156 1.669 1.669 0 01-.153.13l.01-.824.063.05zm.04-3.046a.36.36 0 01.193.375l-.003.022a.185.185 0 01-.004.023l-.01.046a1.05 1.05 0 01-.108.272c-.042.08-.093.156-.15.231l.01-1a.41.41 0 01.072.031z"
 style={{'--f-12-1Hgi5r': fill3}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}